
import Group from 'vux/src/components/group/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Divider from 'vux/src/components/divider/index.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import Popup from 'vux/src/components/popup/index.vue'

import axios from "axios";
import { setUrlParam } from '@/plugins/utils'

export default {
name: "Login",
components: {
Group,
XInput,
Divider,
PopupPicker,
Popup
},
data() {
let selectAllData = [["学校", "教师", "家长", "学生"]];
return {
schoolInfo: {},
placeholder: "手机号",
curActionUrl: "",
loginData: {
mobile: "",
pwd: "",
captcha: "1234",
nowRole: "",
targetUrl: "",
schoolId: localStorage.getItem("schoolId"),
openId: localStorage.getItem("openId" + localStorage.getItem("schoolId"))
},
selectData: ["家长"],
selectAllData,
disabled: true,
isStudent: false,
pwdType: true,
mobileBottom: false,
pwdBottom: false,
selectDialogShow: true,
selectInfoShow: true,
validatorPwd: val => {
return {
valid: val.length >= 6,
msg: "密码必须大于6位数"
};
}
};
},
watch: {
"loginData.mobile": function(val) {
if (val !== "") {
this.disabled = false;
} else {
this.disabled = true;
}
}
},
async created() {

let schoolId = localStorage.getItem("schoolId");

let openId = localStorage.getItem("openId" + schoolId) || localStorage.getItem("openId");








openId = '1';

const hasHrefOpenID = window.location.href.search('openId=');
if (schoolId || (!openId && hasHrefOpenID === -1) ) {
try {
const localSchoolInfo = JSON.parse(localStorage.getItem("schoolInfo") || "{}");
this.schoolInfo = localSchoolInfo;
if (parseInt(localSchoolInfo.id) !== parseInt(schoolId) || !openId) {
axios({
method: "post",
url: process.env.VUE_APP_BASE_URL + "/login/school-info",
data: {
schoolId,
},
headers: {
schoolId,
}
}).then(res => {
if (res.status == 200 & res.data.code == 0) {
localStorage.setItem("schoolInfo", JSON.stringify(res.data.content))
this.schoolInfo = res.data.content;
if (!openId && hasHrefOpenID === -1) {
window.location.href = res.data.content && res.data.content.wechatRedirect;

}
}

}).catch(e => {
console.log(e)
})
}
} catch (error) {
console.log(error);
}
}
this.curActionUrl = this.ActionUrl.school;
if (this.lastLoginInfo) {
switch (this.lastLoginInfo.nowRole) {
case "school":
this.selectData[0] = "学校";
break;
case "teacher":
this.selectData[0] = "教师";
break;
case "parent":
this.selectData[0] = "家长";
break;
case "student":
this.selectData[0] = "学生";
break;
default:
break;
}
}
if (this.selectData[0] == "学生") this.placeholder = "学籍号";
},
methods: {

changeRole(role) {
if (role[0] == "学生") return (this.placeholder = "学籍号");
return (this.placeholder = "手机号");
},
goForget() {
if (this.selectData.length === 0) {
this.$message.cancel("请选择角色");
} else {
this.$router.push({
name: "forge",
query: {
type: this.selectData[0]
}
});
}
},
createInput(options) {
let input = document.createElement("input");
let div = document.createElement("div");
for (let k in options) {
input.setAttribute(k, options[k]);
div.appendChild(input);
}
return div;
},
/**
* 切换身份标识
*/
caseRole() {
switch (this.selectData[0]) {
case "学校":
this.loginData.nowRole = "school";
break;
case "教师":
this.loginData.nowRole = "teacher";
break;
case "家长":
this.loginData.nowRole = "parent";
break;
case "学生":
this.loginData.nowRole = "student";
break;
default:
break;
}
},
/**
* 表单验证
* 数据组装
* axios提交表单
*/
loginSubmit() {
if (!this.loginData.schoolId)
return this.$message.cancel("获取学校信息失败请返回公众号重新进入~");
if (!this.disabled) {
if (this.selectData.length === 0) {
this.$message.cancel("请选择角色");
} else {
if (
!/^1\d{10}$/.test(this.loginData.mobile) &&
this.selectData[0] !== "学生"
) {
this.$message.cancel("手机号码错误");
return;
}
if (this.loginData.pwd.length < 6) {
this.$message.cancel("密码至少大于6位");
return;
}
if (!this.selectInfoShow) {
this.$message.cancel("请您同意世纪海航产品使用协议");
return;
}
this.caseRole();
let formData = new FormData();
try {
this.loginData.password = this.loginData.pwd;
this.loginData.studentCode = this.loginData.mobile;
this.curActionUrl = this.ActionUrl[this.loginData.nowRole];
for (let k in this.loginData) {
if (this.loginData[k] && k !== "targetUrl")
formData.append(k, this.loginData[k]);
}
} catch (error) {
console.log(error);
}
this.disabled = true;
try {
if (this.loginData.nowRole == "student") {
formData.delete("mobile");
} else {
formData.delete("studentCode");
}
} catch (error) {
console.log(error);
}
this.$nextTick(() => {
axios({
method: "post",
url: this.curActionUrl,
data: formData
})
.then(res => {
if (res.data.code == 0) {
this.$vux.toast.text("登录成功~");
this.loginData.lastLoginTime = Date.now();
localStorage.setItem(
"lastLoginInfo",
encodeURIComponent(JSON.stringify(this.loginData))
);
this.goTarget(res.data.content && res.data.content.token);






return;
}

this.$message.cancel(res.data.msg);
this.disabled = false;
})
.catch(() => {
this.$message.cancel("网络异常请稍后再试");
this.disabled = false;



});
});
}
}
},

goTarget(token) {
const localTarget = sessionStorage.getItem('targetUrl');
if(!localTarget || localTarget === 'undefined') {
this.loginData.targetUrl = this.targetUrl[this.loginData.nowRole];
setTimeout(() => {
this.$nextTick(() => {
this.$refs.submitForm.submit();
});
}, 500);
return;
}

sessionStorage.removeItem('targetUrl');
const url = setUrlParam(localTarget, 'token', token);
window.location.href = url;
}
}
};
